import createCache from '@emotion/cache';
import { useMantineEmotionCache } from '../theme/MantineProvider.js';

const defaultMantineEmotionCache = createCache({ key: "mantine", prepend: true });
function useEmotionCache() {
  const cache = useMantineEmotionCache();
  return cache || defaultMantineEmotionCache;
}

export { defaultMantineEmotionCache, useEmotionCache };
//# sourceMappingURL=use-emotion-cache.js.map
